import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import PropTypes from 'prop-types'

import StakeholderSection from './StakeholderSection'
import ActionText from '../../../../../../../../components/ActionText'

import { initialStakeholder, STAKEHOLDERS_LIST, stakeholderTypeOptions } from '../../../../stakeholdersFields'

import useDrawerFormClasses from '../../../../../../../../styles/common/drawerForms'

const StakeholderDetailsSection = ({ formik, stakeholderSectionInputsPreset = {} }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  const [selectedStakeholderSectionIndex, setSelectedStakeholderSectionIndex] = useState(0)

  const { values, setFieldValue } = formik

  const stakeholdersList = values[STAKEHOLDERS_LIST]

  const allowAddAnotherStakeholder = useMemo(() => {
    return stakeholdersList.length < stakeholderTypeOptions.length
  }, [stakeholdersList])

  const addAnotherStakeholderText = useMemo(() => {
    return values[STAKEHOLDERS_LIST].length > 0 ? t('Add another stakeholder') : t('Add stakeholder')
  }, [values, t])

  const handleAddAnotherStakeholder = useCallback(() => {
    // add new initial assumption to assumptions array
    const currentStakeholders = values[STAKEHOLDERS_LIST]

    // open new assumption section
    setSelectedStakeholderSectionIndex(currentStakeholders.length)
    setFieldValue(STAKEHOLDERS_LIST, [
      ...currentStakeholders,
      {
        ...initialStakeholder,
        ...stakeholderSectionInputsPreset,
        id: uuidv4()
      }
    ])
  }, [setFieldValue, values, stakeholderSectionInputsPreset])

  const handleDeleteStakeholder = useCallback(
    index => {
      const newStakeholdersList = [...stakeholdersList]
      newStakeholdersList.splice(index, 1)

      // open previous assumption section if it exists
      const nextSelectedIndex = index > 0 ? index - 1 : null
      setSelectedStakeholderSectionIndex(nextSelectedIndex)
      setFieldValue(STAKEHOLDERS_LIST, newStakeholdersList)
    },
    [stakeholdersList, setFieldValue]
  )

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Stakeholder Details')}</h3>

      {stakeholdersList.map((stakeholder, index) => (
        <StakeholderSection
          formik={formik}
          index={index}
          key={stakeholder.id}
          isSelected={selectedStakeholderSectionIndex === index}
          onSelect={() => setSelectedStakeholderSectionIndex(index)}
          onClose={() => setSelectedStakeholderSectionIndex(null)}
          onDelete={() => handleDeleteStakeholder(index)}
        />
      ))}
      {!!allowAddAnotherStakeholder && (
        <ActionText onClick={handleAddAnotherStakeholder} isDark>
          {t(addAnotherStakeholderText)}
        </ActionText>
      )}
    </section>
  )
}

StakeholderDetailsSection.propTypes = {
  formik: PropTypes.object.isRequired,
  stakeholderSectionInputsPreset: PropTypes.object
}

export default StakeholderDetailsSection
